import { State as AdminclubQuestionOfTheDayState } from 'mk2/apps/adminclub/containers/AdminclubQuestionOfTheDay/AdminclubQuestionOfTheDay.reducers';
import { ConceptsHierarchyPageState } from 'mk2/apps/adminclub/containers/ConceptsHierarchy/ConceptsHierarchy.reducers';
import {
    conceptTaggingWidgetsReducer,
    ConceptTaggingWidgetsState,
} from 'mk2/apps/adminclub/containers/ConceptTaggingWidget/ConceptTaggingWidget.reducers';
import { TaggingTabsState } from 'mk2/apps/adminclub/containers/TaggingTabs/TaggingTabs.reducers';

export interface AdminclubAppState {
    conceptTagging: ConceptTaggingWidgetsState;
    concepts: ConceptsHierarchyPageState;
    taggingTabs: TaggingTabsState;
    questionOfTheDay: AdminclubQuestionOfTheDayState;
}

export const adminclubReducer = {
    conceptTagging: conceptTaggingWidgetsReducer,
};
